import i18next from 'i18next';

i18next.addResources('es_CL', 'PublicMenu', {
  menu: 'Menú',
  menuDescription: 'Menú'
});
